import {
  inject,
  computed,
} from '@vue/composition-api';

export default (props) => {
  const productName = inject('productName');

  const coverType = computed(() => {
    return props?.formData?.home.propertyCoverType;
  });

  const modalContent = computed(() => {
    const content = {
      rows: [
        'Your age',
      ],
      detailsMsg: '',
    };

    switch (productName) {
      case 'home': {
        const getHomeRows = (coverType) => {
          const variations = {
            B: ['Years of Buildings NCD (No Claims Discount)'],
            C: ['Years of Contents NCD (No Claims Discount)'],
            get BC () {
              return [this.B, this.C].flat();
            },
          };

          return variations[coverType];
        };

        content.rows.push(...getHomeRows(coverType.value));
        content.detailsMsg = 'claims';
        break;
      }

      default: {
        content.rows.push('Years of NCD (No Claims Discount)', 'Years license held');
        content.detailsMsg = 'claims or convictions';
      }
    }

    return content;
  });

  return {
    modalContent,
  };
};
